import TmapRouteViewer from "../../components/viewer/tmap/TmapRouteViewer";

const Stock = () => {
  return (
    <div>
      <h2>물류 관리</h2>
      <TmapRouteViewer />
    </div>
  );
};

export default Stock;
